import useShop from "../../utility/hooks/useShop";

export const useOnlineBookingHelper = () => {
  const shop = useShop();

  const isNewClientBookingDisabled = () => {
    if (shop?.feature_settings?.new_client_booking_enabled === undefined || shop.feature_settings.new_client_booking_enabled === true) return false;
    return true;
  };

  const isReturningClientBookingDisabled = () => {
    if (shop?.feature_settings?.returning_client_booking_enabled === undefined || shop.feature_settings.returning_client_booking_enabled === true) return false;
    return true;
  };

  const isOnlineBookingDisabled = () => {
    return isNewClientBookingDisabled() && isReturningClientBookingDisabled();
  };

  const isPetPortalEnabled = () => {
    if (shop?.feature_settings?.pet_medical_records_v1_enabled !== undefined && shop.feature_settings.pet_medical_records_v1_enabled === true) return true;
    return false;
  };

  return {
    isNewClientBookingDisabled,
    isReturningClientBookingDisabled,
    isOnlineBookingDisabled,
    isPetPortalEnabled,
  };
};
